/** Keep a technical column id unless it is missing or already used. */
export const stableColumnId = (id: number | undefined, usedIds: Set<number>) => {
	if (id != null && id > 0 && !usedIds.has(id)) {
		usedIds.add(id)
		return id
	}

	let nextId = Math.max(0, ...usedIds) + 1
	while (usedIds.has(nextId)) nextId += 1
	usedIds.add(nextId)
	return nextId
}
